/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React, { memo } from 'react';
import { View } from '@az/starc-ui';
import { CMSLink } from '@/features/contentstack/components/CMSLink/CMSLink';
import styles from '../BlogMenuNavigation.module.scss';
import { type ContentStackLink } from '@/features/contentstack/interface/content-types';

export type MenuLink = {
  menu_link?: ContentStackLink;
};

type MenuLinkGridProps = {
  linkColumns: MenuLink[][];
  onLinkClick: () => void;
};

const MenuLinkGrid = memo(({ linkColumns, onLinkClick }: MenuLinkGridProps) => {
  if (!linkColumns || linkColumns.length === 0) {
    return null;
  }

  return (
    <>
      {linkColumns.map((column, index) => (
        <React.Fragment key={index}>
          <View className={styles.menuLinksColumn}>
            {column.map((linkItem, linkIndex) => (
              <View key={linkIndex} className={styles.menuLinkItem}>
                <CMSLink to={linkItem?.menu_link?.href || ''} onClick={onLinkClick}>
                  {linkItem?.menu_link?.title}
                </CMSLink>
              </View>
            ))}
          </View>
          {index < linkColumns.length - 1 && <View className={styles.columnSeparator} />}
        </React.Fragment>
      ))}
    </>
  );
});

MenuLinkGrid.displayName = 'MenuLinkGrid';

export default MenuLinkGrid;
